import { render, staticRenderFns } from "./FractionsStrip.vue?vue&type=template&id=7b290700"
import script from "./FractionsStrip.vue?vue&type=script&lang=js"
export * from "./FractionsStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports